const environment = {
  api: process.env.REACT_APP_API_URL,
  chat_api: process.env.REACT_APP_API_URL,
  userRoleId: process.env.REACT_APP_USER_ROLE_ID,
  adminRoleId: process.env.REACT_APP_ADMIN_ROLE_ID,
  staffRoleId: process.env.REACT_APP_STAFF_ROLE_ID,
  contractorRoleId: process.env.REACT_APP_CONTRACTOR_ROLE_ID,
  supplierRoleId: process.env.REACT_APP_SUPPLIER_ROLE_ID,
  map_api_key: process.env.REACT_APP_MAP_API_KEY,
  captcha_site_key: process.env.REACT_APP_CAPTCHA_SITE_KEY,
  businessUserRoleId: process.env.REACT_APP_BUSINESSUSER_ROLE_ID,
  front_web_url: process.env.REACT_APP_FRONT_WEB_URL,
  accountantRoleId: process.env.REACT_APP_ACCOUNTANT_ROLE_ID,
  businessStaffRoleId: process.env.REACT_APP_BUSINESS_STAFF_ROLE_ID,
  toolsSupplierRoleId: process.env.REACT_APP_TOOLS_SUPPLIER_ROLE_ID,
  editor_key: process.env.REACT_APP_API_KEY,
  manufactureRoleId: process.env.REACT_APP_MANUFACTURER_ROLE_ID,
  googleStorageUrl: process.env.REACT_APP_GOOGLE_IMAGE_URL,
};
export default environment;
